export default __webpack_public_path__ + "84ebe5c5d1efba66e8e2d158b37463c7.png";